'use strict';

/*
 * Configure httpProvider to combine processing of multiple requests, useful
 * for increasing performance at bootstrap time
 * See https://docs.angularjs.org/api/ng/provider/$httpProvider
 */
var AppConfig = function ($httpProvider, $compileProvider, $logProvider) {
  $httpProvider.useApplyAsync(true);
  $compileProvider.debugInfoEnabled(false);
  $compileProvider.preAssignBindingsEnabled(true);
  $logProvider.debugEnabled(false);
};

AppConfig.$inject = ['$httpProvider', '$compileProvider', '$logProvider'];
module.exports = AppConfig;



// WEBPACK FOOTER //
// ./src/app/AppConfig.js